/**
 * Active account context — master can switch to a sub-account (ys142857 子账户切换).
 * JWT stays on master; reads use ?account_id= for subs.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ActiveAccountState {
  /** null = main (master) account */
  accountId: number | null;
  username: string | null;
  setActiveAccount: (accountId: number | null, username: string | null) => void;
  clearActiveAccount: () => void;
}

export const useActiveAccountStore = create<ActiveAccountState>()(
  persist(
    (set) => ({
      accountId: null,
      username: null,
      setActiveAccount: (accountId, username) => set({ accountId, username }),
      clearActiveAccount: () => set({ accountId: null, username: null }),
    }),
    { name: 'uo-active-account' },
  ),
);

/** Effective user id for balance/profile reads. */
export function useEffectiveAccountId(masterId: number | undefined): number | undefined {
  const activeId = useActiveAccountStore((s) => s.accountId);
  if (!masterId) return undefined;
  return activeId ?? masterId;
}

/** Query params for master viewing a linked sub-account. */
export function useViewAsAccountParams(): { account_id: number } | undefined {
  const accountId = useActiveAccountStore((s) => s.accountId);
  return accountId != null ? { account_id: accountId } : undefined;
}
